<div class="navbar"><button routerLink="/planner">Start Tour</button></div><ng-content></ng-content>